/**
 * Session restore is handled in AuthContext (validates token via /auth/me).
 * Kept as a passthrough for test utilities that wrap with AuthPersist.
 */
const AuthPersist = ({ children }) => children;

export default AuthPersist;
